import styled from "styled-components";

export const TextContent = styled.span<{ color: string }>`
  font-weight: bold;
  color: ${({ color }) => color}
`;